export const ScanningOverlay = () => (
  <div
    className="absolute top-[-5px] bottom-[-5px] w-1 bg-red-500 opacity-90 shadow-lg blur-[1px] z-20 rounded-full animate-scan"
    data-testid="scanning-bar"
  />
);
